module.exports = __webpack_public_path__ + "static/media/weld_wps_3.a7d42a84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/weld_wps_3.jpg
// module id = 1910
// module chunks = 0